<script>
import Modal from "@/components/_Shared/Modal/Index";
import Title from "@/components/_Shared/Title";
import Tip from "@/components/_base/Tip";

import OrderCard from "../../../Order/Components/Card/Index";
import CycleCard from "../../../Cycle/Components/Card";

export default {
  components: {
    Modal,
    Title,
    Tip,
    OrderCard,
    CycleCard
  },

  props: {
    cycles: {
      type: Array,
      required: true
    },
    orders: {
      type: Array,
      required: true
    }
  }
};
</script>

<template>
  <Modal>
    <template slot="header">
      <Title title="Pedidos pendentes de pagamento" />
    </template>

    <template slot="body">
      <div>
        <CycleCard
          v-for="cycle in cycles"
          :key="cycle.id"
          :payable="cycle"
        />

        <OrderCard
          v-for="order in orders"
          :key="order.id"
          :payable="order"
        />
      </div>
    </template>

    <template slot="footer">
      <Tip>Selecione o pedido ou assinatura que você deseja realizar o pagamento</Tip>

      <button
        class="btn bg-purple"
        @click="$emit('close')"
      >
        <span>Voltar</span>
      </button>
    </template>
  </Modal>
</template>



// WEBPACK FOOTER //
// src/components/Dashboard/components/Payables/PendingPayablesList.vue